<template>
  <div>
    <ul class="pagination" v-if="data.length >= 5 || currentPage > 1">
      <li class="pagination-item">
        <button
          type="button"
          class="btn btn-primary"
          @click="onClickFirstPage"
          :disabled="isInFirstPage"
        >
          <font-awesome-icon icon="angle-double-left" class="m-0" />
        </button>
      </li>

      <li class="pagination-item">
        <button
          type="button"
          class="btn btn-primary"
          @click="onClickPreviousPage"
          :disabled="isInFirstPage"
        >
          <font-awesome-icon icon="angle-left" class="m-0" />
        </button>
      </li>

      <!-- Visible Buttons Start -->

      <li class="pagination-item" v-for="(page, index) in pages" :key="index">
        <button
          type="button"
          class="btn btn-primary btn-page"
          @click="onClickPage(page.number)"
          :disabled="page.isDisabled"
          :class="{ active: isPageActive(page.number) }"
        >
          {{ page.number }}
        </button>
      </li>

      <!-- Visible Buttons End -->

      <li class="pagination-item">
        <button
          type="button"
          class="btn btn-primary"
          @click="onClickNextPage"
          :disabled="isInLastPage"
        >
          <font-awesome-icon icon="angle-right" class="m-0" />
        </button>
      </li>

      <li class="pagination-item">
        <button
          type="button"
          class="btn btn-primary"
          @click="onClickLastPage"
          :disabled="isInLastPage"
        >
          <font-awesome-icon icon="angle-double-right" class="m-0" />
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    data: {
      type: Array,
      required: true,
    },
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return (
          this.totalPages -
          this.maxVisibleButtons +
          (this.maxVisibleButtons - 1)
        );
      }

      return this.currentPage - 1;
    },
    endPage() {
      return Math.min(
        this.startPage + this.maxVisibleButtons - 1,
        this.totalPages
      );
    },
    pages() {
      let range = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        range.push({
          number: i,
          isDisabled: i === this.currentPage,
        });
      }
      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    onClickFirstPage() {
      this.$emit("pagechanged", 1);
    },
    onClickPreviousPage() {
      this.$emit("pagechanged", this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit("pagechanged", page);
    },
    onClickNextPage() {
      this.$emit("pagechanged", this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit("pagechanged", this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    },

    onPageChange(page) {
      console.log(page);
    },
  },
};
</script>
<style scoped>
.pagination {
  list-style-type: none;
  font-family: Arial, Helvetica, sans-serif;
}

.pagination-item {
  display: inline-block;
  margin-left: 8px;
}

.active {
  background-color: #3782f3 !important;
  color: #fff !important;
  border-color: #3782f3 !important;
}

button {
  background-color: #ffffff !important;
  color: #595959 !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 5px !important;
  padding: 0.23rem 0.6rem !important;
}

button:focus {
  box-shadow: none !important;
}

button:hover {
  border-color: #3782f3 !important;
}
</style>
